/**
 * ClickUp webhook event payloads (v2 API).
 * https://developer.clickup.com/docs/webhooks/overview
 */
/**
 * What a customer→tag mapping keys off:
 * - `customer_field` — a Boolean column on the customer (e.g. `changeControlled`). The
 *   selectable list is read from the schema at runtime, so columns added later appear
 *   automatically.
 * - `customer_type` — one of the admin-managed customer types, which render as checkboxes
 *   on the customer form.
 */
export const CLICKUP_CUSTOMER_TAG_SOURCE_KINDS = ['customer_field', 'customer_type'];
export const CLICKUP_CUSTOMER_TAG_SOURCE_KIND_LABELS = {
    customer_field: 'Customer field',
    customer_type: 'Customer type',
};
//# sourceMappingURL=clickup.js.map